import React from "react";
import MainNews from "./components/MainNews";

import Welcome from "./components/Welcome";
import Services from "./components/Services";
import OnlineServices from "./components/OnlineServices";
import Calendar from "./components/Calendar";
import Addresses from "./components/Addresses";
import Websites from "./components/Websites";
import Bildirishler from "./components/Bildirishler";
import About from "./components/About";
import { MessageForm } from "./components/MessageForm";
import Subscribe from "../../partials/header/components/Subscribe";

const Home = () => {
  return (
    <main>
      <MainNews />
      <Welcome />
      <Services />
      <OnlineServices />
      <Calendar />
      <Addresses />
      <Websites />
      <Bildirishler />
      <MessageForm />
      <About />
      <div className="green-bg bottom-subscribe">
        <div className="container py-4">
          <div className="row">
            <div className="col-12">
              <Subscribe />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
